import React, { FC, useState } from 'react';
import Alert from './AlertBox';
import styles from '../../css/Alert.module.scss';
import { Props as IAlert } from './AlertBox';

interface IAlertContext {
	show: (params: IAlert) => IAlert;
}

const defaultState = {
	show: (params: IAlert): IAlert => {
		return {
			title: params.title,
			body: params.body,
			type: params.type,
		};
	},
};

const AlertContext = React.createContext<IAlertContext>(defaultState);

export const AlertProvider: FC = ({ children }) => {
	const [alerts, setAlerts] = useState<IAlert[]>([]);
	const show = ({ title, body, type }: IAlert) => {
		setAlerts([...alerts, { title, body, type }]);
		setTimeout(() => {
			setAlerts(alerts.filter((e) => e.title !== title));
		}, 3000);
		return { title, body, type };
	};
	return (
		<AlertContext.Provider
			value={{
				show,
			}}
		>
			{children}
			<div className={styles['root-container']}>
				{alerts.map((e) => (
					<Alert title={e.title} body={e.body} type={e.type} />
				))}
			</div>
		</AlertContext.Provider>
	);
};

export default AlertContext;
